import { Badge } from "./Badge";

const mrpCategoryVariant = {
  INDICATION: "info",
  EFFECTIVENESS: "warning",
  SAFETY: "high",
  ADHERENCE: "primary",
} as const;

const mrpSeverityVariant = {
  LOW: "neutral",
  MODERATE: "warning",
  HIGH: "high",
  CRITICAL: "critical",
} as const;

export function MrpCategoryBadge({ category, label }: { category: keyof typeof mrpCategoryVariant; label: string }) {
  return <Badge variant={mrpCategoryVariant[category]}>{label}</Badge>;
}

export function MrpSeverityBadge({ severity, label }: { severity: keyof typeof mrpSeverityVariant; label: string }) {
  return <Badge variant={mrpSeverityVariant[severity]}>{label}</Badge>;
}

const flagSeverityVariant = { INFO: "info", WARNING: "warning", HIGH: "high" } as const;

export function ClinicalFlagBadge({ severity, label }: { severity: keyof typeof flagSeverityVariant; label: string }) {
  return <Badge variant={flagSeverityVariant[severity]}>{label}</Badge>;
}
